import Catalog from '@/models/Catalog'
import User, { hasRole, Role } from '@/models/User'

export default class CatalogPolicy {
    viewAny(_user: User) {
        return false
    }

    view(user: User, catalog: Catalog) {
        switch (user.role) {
            case Role.USER:
                return user.company?.id === catalog.company.id
            case Role.AUDITOR:
                return catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
            default:
                return false
        }
    }


    create(user: User) {
        return hasRole(user, Role.USER)
    }

    update(user: User, catalog: Catalog) {
        return hasRole(user, Role.USER) && user.company?.id === catalog.company.id
    }

    restore(user: User, catalog: Catalog) {
        return hasRole(user, Role.USER) && user.company?.id === catalog.company.id
    }

    delete(user: User, catalog: Catalog) {
        return hasRole(user, Role.USER) && user.company?.id === catalog.company.id
    }

    forceDelete(_user: User, _catalog: Catalog) {
        return false
    }

    submit(user: User, catalog: Catalog) {
        return hasRole(user, Role.USER) && user.company?.id === catalog.company.id
    }

    approve(user: User, catalog: Catalog) {
        return hasRole(user, Role.AUDITOR) && catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
    }

    complete(user: User, catalog: Catalog) {
        return hasRole(user, Role.USER) && user.company?.id === catalog.company.id
    }
}
